import { useApolloClient } from '@apollo/client';
import { Scalars } from '@bechtel/types';
import { addDays, formatISO } from 'date-fns';
import { gql } from '@apollo/client';
import { forEach } from 'lodash';
import { useCrewChangeRequestsByIds, useCrewChangeStatsQuery } from '~/hooks/use-crew-change';

export function useCrewChangeCache() {
  const [getCrewChangeRequestByIds] = useCrewChangeRequestsByIds(true);
  const [getCrewChangeStats] = useCrewChangeStatsQuery(true);

  const client = useApolloClient();

  const updateCrewChangeRequestCache = (crewChangeRequestIds: Scalars['ID'][]) => {
    if (!crewChangeRequestIds || crewChangeRequestIds.length == 0) return;

    getCrewChangeStats({
      variables: {
        input: {
          startDate: formatISO(addDays(new Date(), -6), { representation: 'date' }),
          endDate: formatISO(new Date(), { representation: 'date' }),
        },
      },
    }); //Update the stats.

    const cachedCrewChangeRequestIds: string[] = [];

    forEach(crewChangeRequestIds, (crewChangeRequestId) => {
      const cachedCrewChangeRequest = client.readFragment({
        id: 'CrewChangeRequest:' + crewChangeRequestId,
        fragment: gql`
          fragment CrewChangeRequestItemId on CrewChangeRequest {
            id
          }
        `,
      });
      if (cachedCrewChangeRequest) cachedCrewChangeRequestIds.push(crewChangeRequestId);
    });

    if (cachedCrewChangeRequestIds.length == 0) return;

    getCrewChangeRequestByIds({
      variables: {
        ids: cachedCrewChangeRequestIds,
      },
    });
  };
  return { updateCrewChangeRequestCache };
}
